import { render, staticRenderFns } from "./CategoryNew.vue?vue&type=template&id=69695d84&scoped=true&"
import script from "./CategoryNew.vue?vue&type=script&lang=ts&"
export * from "./CategoryNew.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryNew.vue?vue&type=style&index=0&id=69695d84&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69695d84",
  null
  
)

export default component.exports